export default class CustomerPassword{
    public currentPassword = "";
    public newPassword = "";
    public newPasswordConfirmation = "";
}